import { render, staticRenderFns } from "./LKAsideMenuItemTopicLK.vue?vue&type=template&id=580be3ec&"
import script from "./LKAsideMenuItemTopicLK.vue?vue&type=script&lang=js&"
export * from "./LKAsideMenuItemTopicLK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports